import {
  Paper,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";

const ProjectList = ({ img, title, info, site }) => {
  return (
    <div className="col-md-6 col-lg-4 col-10 mx-auto mx-md-0">
      <Paper elevation={20}>
        <Card className="project-card my-3">
          <a href={site} className="project-link" target="_blank">
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Picture"
                height="140"
                image={img}
              />
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="h2"
                  className="text-center text-capitalize my-2"
                >
                  {title}
                </Typography>
                <div className="mt-3">
                  <h6 className="project-h6">Used:</h6>
                  <p className="project-para1 text-uppercase">{info}</p>
                </div>
              </CardContent>
            </CardActionArea>
          </a>
        </Card>
      </Paper>
    </div>
  );
};

export default ProjectList;
